import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { merchantResource } from '@/views/payment/merchantManage/request';
import { BILLINGMETHOD, ACCOUNTTYPE, CONSOLIDATEDCOLUMN1, CONSOLIDATEDCOLUMN2, CONSOLIDATEDCOLUMN3, CONSOLIDATEDCOLUMN4, DIRECTCOLUMN } from './../utils';
import topTitle from '@/components/title';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    topTitle
  },
  data() {
    return {
      BILLINGMETHOD,
      ACCOUNTTYPE,
      CONSOLIDATEDCOLUMN1,
      CONSOLIDATEDCOLUMN2,
      CONSOLIDATEDCOLUMN3,
      CONSOLIDATEDCOLUMN4,
      DIRECTCOLUMN,
      product: '',
      payment: '',
      releaseInfo: '',
      dialogVisible: false,
      dataFrom: {
        amountSplitting: undefined,
        splitSetup: 1
      },
      accountInfo: {
        name: '',
        tableData: []
      },
      accountSharingInfo: {
        name: '',
        tableData: []
      },
      resourcesInfo: {
        accountType: undefined,
        accountId: undefined,
        type: 4
      },
      resourcesSharingInfo: {
        accountType: undefined,
        accountId: undefined,
        type: 4
      },
      payIdType: [],
      payObj: null,
      accountList: [],
      loading: false,
      loadingSharing: false
    };
  },
  computed: {
    dataRule() {
      return {
        amountSplitting: [{
          required: true,
          message: this.$t('请选择') + this.$t('分账方式'),
          trigger: 'change'
        }],
        splitSetup: [{
          required: true,
          message: this.$t('请选择') + this.$t('分账设置'),
          trigger: 'change'
        }],
        accountType: [{
          required: true,
          validator: this.validateAccountType
        }],
        payIdType: [{
          required: true,
          validator: this.validatePayIdType,
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    validateAccountType(rule, value, callback) {
      callback();
    },
    validatePayIdType(rule, value, callback) {
      if (this.payIdType.length == 0) {
        callback(new Error(this.$t('请选择') + this.$t('支付ID')));
      } else {
        callback();
      }
    },
    init(product, releaseInfo, payment) {
      this.product = product;
      // this.payment = payment;
      const payment1 = recursionCopy(payment);
      if (payment.payList.length != 0) {
        this.dataFrom = {
          amountSplitting: payment1.amountSplitting,
          splitSetup: payment1.splitSetup
        };
        if (payment1.amountSplitting == 1) {
          this.accountList = payment1.payList;
          this.payObj = this.accountList.find(item => item.isMain);
          this.payIdType = this.payObj.payIdTypeChoose;
        } else if (payment1.amountSplitting == 2) {
          this.accountInfo.tableData = [];
          this.accountList = [];
          payment1.payList.map(item => {
            if (item.isMain) {
              this.accountInfo.tableData.push(item);
            } else {
              item.checked = true;
              this.accountList.push(item);
            }
          });
          this.payObj = this.accountInfo.tableData.find(item => item.isMain);
          this.payIdType = this.payObj.payIdTypeChoose;
          this.accountSharingInfo.tableData = this.accountList;
        } else {
          this.accountInfo.tableData = [];
          payment1.payList.map(item => {
            if (item.isMain) {
              this.accountInfo.tableData.push(item);
            }
          });
          this.payObj = this.accountInfo.tableData.find(item => item.isMain);
          this.payIdType = this.payObj.payIdTypeChoose;
        }
      }
      this.releaseInfo = releaseInfo;
      this.dialogVisible = true;
    },
    amountSplittingChange() {
      this.selectionRows = [];
      this.payObj = null;
      this.accountInfo = {
        name: '',
        tableData: []
      };
      this.resourcesInfo = {
        accountType: undefined,
        accountId: undefined,
        type: 4
      };
      this.accountSharingInfo = {
        name: '',
        tableData: []
      };
      this.resourcesSharingInfo = {
        accountType: undefined,
        accountId: undefined,
        type: 4
      };
      this.payIdType = [];
      this.dataFrom.splitSetup = this.dataFrom.amountSplitting == 3 ? undefined : 1;
      this.accountList = [];
      // this.$refs['dataFrom'].resetFields();
    },
    accountTypeChange(val) {
      const id = val == 0 ? this.releaseInfo.customerId : val == 1 ? this.product.agencyId : val == 2 ? this.product.intermediaryId : 10;
      this.resourcesInfo.accountId = id;
      if (this.dataRule.amountSplitting == 1) {
        this.accountInfo.tableData.map(item => {
          const index = this.accountList.findIndex(item2 => item2.id == item.id);
          if (index != -1 && !item.checked) {
            this.accountList.splice(index, 1);
          } else if (index == -1 && item.checked) {
            this.accountList.push(item);
          }
        });
        this.selectionRows = this.accountInfo.tableData.filter(item => item.checked);
      } else if (this.dataFrom.amountSplitting == 2) {
        this.accountInfo.tableData = [];
        this.selectionRows = [];
        this.payObj = null;
        this.payIdType = [];
        this.accountSharingInfo.tableData.map(item => {
          const index = this.accountList.findIndex(item2 => item2.id == item.id);
          item.checked = index != -1 ? true : false;
        });
      } else if (this.dataFrom.amountSplitting == 3) {
        this.accountInfo.tableData = [];
        this.selectionRows = [];
        this.payObj = null;
        this.payIdType = [];
      }
      console.log(this.accountList);
      this.loading = true;
      this.getDataFun();
    },
    accountTypeSharingChange(val) {
      const id = val == 0 ? this.releaseInfo.customerId : val == 1 ? this.product.agencyId : val == 2 ? this.product.intermediaryId : 10;
      this.resourcesSharingInfo.accountId = id;
      this.loadingSharing = true;
      this.getSharingDataFun();
    },
    async getDataFun() {
      const {
        paymentMerchantList,
        customerName
      } = await merchantResource(this.resourcesInfo);
      this.accountInfo.name = customerName;
      const arr = recursionCopy(this.accountList);
      this.accountInfo.tableData = paymentMerchantList.map(item => {
        const obj = arr.find(item2 => item.id == item2.id);
        item.checked = obj ? true : false;
        return item;
      });
      this.loading = false;
    },
    async getSharingDataFun() {
      const {
        paymentMerchantList,
        customerName
      } = await merchantResource(this.resourcesSharingInfo);
      this.accountSharingInfo.name = customerName;
      const arr = this.accountInfo.tableData.filter(item => item.isMain);
      const arr2 = recursionCopy(this.accountList).concat(recursionCopy(arr));
      console.log(arr2);
      this.accountSharingInfo.tableData = paymentMerchantList.map(item => {
        const obj = arr2.find(item2 => item.id == item2.id);
        item.checked = obj ? true : false;
        return item;
      });
      this.loadingSharing = false;
    },
    consolidatedChange(val, index, type) {
      if (type == 2 && this.accountList.length == 3) {
        return this.$message.error(this.$t('当前分账方式最多选择3个接收分账商户'));
      }
      // if (!val.share) {
      //   console.log(this.dataFrom.splitSetup);
      //   const cont=this.dataFrom.splitSetup == 1 ? '收款比例':'固定金额';
      //   return this.$message.error('请输入' + cont + '才可以选择');
      // }
      if (type == 1) {
        this.accountList.push(Object.assign(val, {
          isMain: false
        }));
        this.accountInfo.tableData[index].checked = true;
      } else if (type == 2) {
        this.accountList.push(Object.assign(val, {
          isMain: false,
          name: this.accountSharingInfo.name
        }));
        this.accountSharingInfo.tableData[index].checked = true;
        this.accountInfo.tableData.map(item => {
          if (item.id == val.id) {
            item.checked = true;
          }
        });
      }
    },
    radioChange(val) {
      this.payObj = null;
      this.payIdType = [];
      this.accountList.map((item, index) => {
        item.isMain = index == val ? true : false;
      });
      this.payObj = this.accountList.find(item => item.isMain);
    },
    radioDirectChange(val) {
      this.payObj = null;
      this.payIdType = [];
      this.accountInfo.tableData.map((item, index) => {
        item.isMain = index == val ? true : false;
      });
      this.payObj = this.accountInfo.tableData.find(item => item.isMain);
    },
    radioSharingChange(val, obj) {
      // if(!obj.share){
      //   const cont=this.dataFrom.splitSetup == 1 ? '收款比例':'固定金额';
      //   return this.$message.error('请输入' + cont + '才可以选择');
      // }
      this.payObj = null;
      this.payIdType = [];
      this.accountInfo.tableData.map((item, index) => {
        item.isMain = index == val ? true : false;
      });
      this.payObj = this.accountInfo.tableData.find(item => item.isMain);
      this.accountSharingInfo.tableData.map(item => {
        item.checked = item.id == obj.id ? true : false;
      });
    },
    consolidatedDelete(val, index) {
      this.accountList.splice(index, 1);
      this.accountInfo.tableData.map(item => {
        if (item.id == val.id) {
          item.checked = false;
        }
      });
      const payObj = this.accountList.find(item => item.isMain);
      if (!payObj) {
        this.payObj = null;
        this.payIdType = [];
      }
    },
    handleTagClose(removedTag) {
      this.accountSharingInfo.tableData.map(item => {
        if (item.id == removedTag.id) {
          item.checked = false;
          item.share = '';
        }
      });
      this.accountInfo.tableData.map(item => {
        if (item.id == removedTag.id) {
          item.checked = false;
          item.share = '';
        }
      });
      const tags = this.accountList.filter(tag => tag.id !== removedTag.id);
      this.accountList = tags;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          let accountList = recursionCopy(this.accountList);
          if (this.dataFrom.amountSplitting == 1) {
            if (this.accountList.length < 2) {
              return this.$message.error(this.$t('当前分账方式请至少选择两个商户号，主体商户数量不满足时请前往“支付管理-支付商户号”增加商户号配置'));
            }
            const arr = accountList.filter(item => item.isMain);
            if (arr.length == 0) {
              return this.$message.error(this.$t('必须设置一个商户为主商户'));
            }
          } else if (this.dataFrom.amountSplitting == 2) {
            const collectionsArr = this.accountInfo.tableData.filter(item => item.isMain);
            if (collectionsArr.length == 0) {
              return this.$message.error(this.$t('至少要选择一个收款商户'));
            }
            if (this.accountList.length == 0) {
              return this.$message.error(this.$t('至少要选择一个分账商户,最多三个分账商户'));
            }
            accountList.unshift(collectionsArr[0]);
          } else if (this.dataFrom.amountSplitting == 3) {
            const collectionsArr = this.accountInfo.tableData.filter(item => item.isMain);
            if (collectionsArr.length == 0) {
              return this.$message.error(this.$t('至少要选择一个账户'));
            }
            accountList = recursionCopy(collectionsArr);
          }
          if (this.dataFrom.splitSetup != 3 && this.dataFrom.splitSetup == 1) {
            let num = 0;
            accountList.map(item => {
              num += Number(item.share);
            });
            console.log(num);
            if (num != 100) {
              return this.$message.error(this.$t('分账比例相加必须=100%,请重新配置'));
            }
          }
          let obj = recursionCopy(this.dataFrom);
          obj.payWay = 5;
          obj.payList = [];
          obj.splitSetup = obj.splitSetup ? obj.splitSetup : 0;
          accountList.map(item => {
            let itemObj = {
              isMain: item.isMain,
              merchantId: item.id,
              shareRatio: '',
              shareAmount: '',
              payIdType: []
            };
            if (item.isMain) {
              itemObj.payIdType = this.payIdType;
            }
            if (obj.amountSplitting != 3) {
              if (obj.splitSetup == 1) {
                itemObj.shareRatio = item.share;
              } else if (obj.splitSetup == 2) {
                itemObj.shareAmount = item.share;
              }
            }
            obj.payList.push(itemObj);
          });
          console.log(accountList, obj, this.payIdType);
          this.$emit('ok', obj);
          this.$emit('cancel');
        }
      });
    },
    isReadonly(id, index) {
      var _this$accountInfo$tab;
      let res = (_this$accountInfo$tab = this.accountInfo.tableData.find(i => i.isMain)) === null || _this$accountInfo$tab === void 0 ? void 0 : _this$accountInfo$tab.id;
      if (res && res == id) {
        this.accountSharingInfo.tableData[index].share = undefined;
        return true;
      }
      return false;
    }
  }
};